module.exports = __webpack_public_path__ + "3221eaee8ea4a4a110899743aef3a61a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/wrench.png
// module id = 2147
// module chunks = 0